import { render, staticRenderFns } from "./AuthorTopNavbar.vue?vue&type=template&id=69dbc470"
import script from "./AuthorTopNavbar.vue?vue&type=script&lang=js"
export * from "./AuthorTopNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports